module.exports = __webpack_public_path__ + "df94f008941afafd59266dafb42c30a2.svg";